export enum Stage {
  dev = "dev",
  beta = "beta",
  gamma = "gamma",
  prod = "prod",
}
